// extracted by mini-css-extract-plugin
export default {"input":"FileUpload_input__ZtVah"};